import * as React from "react"
import { App } from "./app"
import { BDKalkCore } from "./BDKalkCore"
import { MakeNational } from "./BDKalkCore"

export interface TotalDisplayVm {
    app: App
}

// TotalDisplayGW shows the total prize of chosen wares in the topright corner
export class TotalDisplayGW extends React.Component<TotalDisplayVm, {}> {
    componentWillMount() {
        this.props.app.GetCore().ConnectTotalDisplay(this)
    }
    
    render() {
        // Putting togeather a string (result) that will show the total sum
        var result = this.props.app.GetCore().TotalSum().toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown ++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        // Returning the result to App.render() where it will be displayed on the top right corner of the page.
        return <div>
            <h4 style={{ color: "white", fontSize: "large", font: "Eras Bold ITC", marginTop: "5px", marginRight: "30px" }}>Totalpris: {MakeNational(result)} NOK</h4>
        </div>
    }
}



// WEBPACK FOOTER //
// ./client/view/TotalDisplayGW.tsx